<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<i (click)="toggleMessage()" class="error-icon"></i>
<!-- <svg><use href="images/icons/exclamation-circle-solid.svg"/></svg> -->
<!-- <div *ngIf="showMessage" (click)="showMessage = false;" class="ticket-error-state-message" style="position: absolute"> -->
<div
	*ngIf="showMessage"
	(click)="showMessage = false"
	#messageRef
	class="popup-widthless--red error-messages error-message-zindex"
>
	<div class="popup-header-red vertical-spacing-md">{{ messageHeader }}</div>
	<div>
		{{ message }}
	</div>
</div>
